module.exports = __webpack_public_path__ + "img/NoSatisfaction.9d86d6ad.png";